// Vipupisteiden valinta (vipupiste_focus.v1): the `vipupisteFocus` namespace, in its own
// file so the module's strings grow here, not in fi.js / en.js / sv.js.
// specs/workshop-modules/vipupiste_focus.md

export const vipupisteFocusFi = {
  title: 'Vipupisteiden valinta',
  loading: 'Ladataan…',
  loadError: 'Vipupisteiden lataus epäonnistui: {{message}}',
  noInstance: 'Työpajaa ei ole valittu: avaa sivu työpajan linkistä (?kid=…).',
  empty: 'Ongelmakartalla ei ole vielä vipupisteitä.',
  leadKeep: 'Mihin vipupisteisiin keskitymme ratkaisuissa? Äänestä enintään {{budget}}. Napauta uudestaan peruaksesi äänen.',
  leadPrune: 'Mitkä vipupisteet jätämme ratkaisuista pois? Äänestä enintään {{budget}}. Napauta uudestaan peruaksesi äänen. Pois jäävät pysyvät kartalla.',
  votesLeft: 'Ääniä jäljellä: {{count}}',
  noVotesLeft: 'Äänesi on käytetty. Peru jokin ääni, jos haluat äänestää toista.',
  voteFailed: 'Ääntä ei tallennettu: {{message}}',
  span: 'Ongelmia: {{count}}',
  countKeep: 'Ääniä: {{count}}',
  countPrune: 'Pois-ääniä: {{count}}',
  locked: 'Valinta on lukittu. Ratkaisuissa jatketaan valituista vipupisteistä ({{count}}).',
  chosen: 'Valittu',
  admin: {
    title: 'Vipupisteiden valinta',
    modeKeep: 'Huone äänestää, mihin keskitytään ({{budget}} ääntä laitetta kohden).',
    modePrune: 'Huone äänestää, mitä jätetään pois ({{budget}} ääntä laitetta kohden).',
    open: 'Äänestys on auki.',
    closed: 'Valinta on lukittu, äänestys on kiinni.',
    lock: 'Lukitse valinta ({{count}}/{{total}})',
    fromVote: 'Palauta äänestyksen mukaan',
    unlock: 'Avaa lukitus',
    unlockHint: 'Lukituksen avaaminen avaa äänestyksen uudelleen. Kerro syy; se jää talteen.',
    unlockPlaceholder: 'Miksi valinta avataan?',
    failed: 'Ei onnistunut: {{message}}',
    openModule: 'Avaa osallistujanäkymä',
  },
};

export const vipupisteFocusEn = {
  title: 'Choosing leverage points',
  loading: 'Loading…',
  loadError: 'Could not load the leverage points: {{message}}',
  noInstance: 'No workshop selected: open this page from the workshop link (?kid=…).',
  empty: 'The problem map has no leverage points yet.',
  leadKeep: 'Which leverage points do we focus our solutions on? Vote for up to {{budget}}. Tap again to take a vote back.',
  leadPrune: 'Which leverage points do we leave out of the solutions? Vote for up to {{budget}}. Tap again to take a vote back. The ones left out stay on the map.',
  votesLeft: 'Votes left: {{count}}',
  noVotesLeft: 'Your votes are used. Take one back to vote for another.',
  voteFailed: 'The vote was not saved: {{message}}',
  span: 'Problems: {{count}}',
  countKeep: 'Votes: {{count}}',
  countPrune: 'Votes to leave out: {{count}}',
  locked: 'The selection is locked. The solutions continue from the chosen leverage points ({{count}}).',
  chosen: 'Chosen',
  admin: {
    title: 'Choosing leverage points',
    modeKeep: 'The room votes for what to focus on ({{budget}} votes per device).',
    modePrune: 'The room votes for what to leave out ({{budget}} votes per device).',
    open: 'Voting is open.',
    closed: 'The selection is locked; voting is closed.',
    lock: 'Lock the selection ({{count}}/{{total}})',
    fromVote: 'Reset to the vote',
    unlock: 'Unlock',
    unlockHint: 'Unlocking reopens the vote. Give a reason; it is kept.',
    unlockPlaceholder: 'Why is the selection reopened?',
    failed: 'Did not work: {{message}}',
    openModule: 'Open the participant view',
  },
};

export const vipupisteFocusSv = {
  title: 'Val av hävstångspunkter',
  loading: 'Laddar…',
  loadError: 'Kunde inte ladda hävstångspunkterna: {{message}}',
  noInstance: 'Ingen workshop vald: öppna sidan från workshopens länk (?kid=…).',
  empty: 'Problemkartan har inga hävstångspunkter ännu.',
  leadKeep: 'Vilka hävstångspunkter fokuserar vi lösningarna på? Rösta på högst {{budget}}. Tryck igen för att ta tillbaka en röst.',
  leadPrune: 'Vilka hävstångspunkter lämnar vi bort från lösningarna? Rösta på högst {{budget}}. Tryck igen för att ta tillbaka en röst. De som lämnas bort finns kvar på kartan.',
  votesLeft: 'Röster kvar: {{count}}',
  noVotesLeft: 'Dina röster är använda. Ta tillbaka en för att rösta på en annan.',
  voteFailed: 'Rösten sparades inte: {{message}}',
  span: 'Problem: {{count}}',
  countKeep: 'Röster: {{count}}',
  countPrune: 'Röster att lämna bort: {{count}}',
  locked: 'Urvalet är låst. Lösningarna fortsätter från de valda hävstångspunkterna ({{count}}).',
  chosen: 'Vald',
  admin: {
    title: 'Val av hävstångspunkter',
    modeKeep: 'Rummet röstar om vad man fokuserar på ({{budget}} röster per enhet).',
    modePrune: 'Rummet röstar om vad som lämnas bort ({{budget}} röster per enhet).',
    open: 'Omröstningen är öppen.',
    closed: 'Urvalet är låst; omröstningen är stängd.',
    lock: 'Lås urvalet ({{count}}/{{total}})',
    fromVote: 'Återställ enligt omröstningen',
    unlock: 'Lås upp',
    unlockHint: 'Att låsa upp öppnar omröstningen igen. Ange ett skäl; det sparas.',
    unlockPlaceholder: 'Varför öppnas urvalet?',
    failed: 'Lyckades inte: {{message}}',
    openModule: 'Öppna deltagarvyn',
  },
};
